import styled from 'styled-components'

export const Wrapper = styled.div`
  /* position: relative; */
`

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 3px;
  /* overflow-y: auto; */
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  overflow-y: auto;
  height: 100%;
  max-height: 408px;
  padding-right: 4px;
`
